import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getBulkQrReportResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getBulkActivationQrReport', data);
        if (response.response.Status) {
            yield put(actions.getBulkQrReportSuccess(response.response.Data));
        } else {
            yield put(actions.getBulkQrReportFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getBulkQrReportFailed(error));
    }
}
function* getBulkQrDetailsResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getBulkActivationQRDetails', data);
        if (response.response.Status) {
            yield put(actions.getBulkQrDetailsSuccess(response.response.Data));
        } else {
            yield put(actions.getBulkQrDetailsFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getBulkQrDetailsFailed(error));
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_BULK_QR_REPORT, getBulkQrReportResponse),
        takeEvery(actions.GET_BULK_QR_DETAILS, getBulkQrDetailsResponse),
    ]);
}